module.exports = __webpack_public_path__ + "img/1STW-1MCB-1PW-2MC-3CB-1TFM.102706f6.png";